export default __webpack_public_path__ + "static/media/914.7c72c42e.png";